import { ListColumns } from 'react-bootstrap-icons';

export default function LeagueIcon(props: any) {

  return (
    <ListColumns {...props} />
  );
}
